; (function ($) {
  // ---------- APP START
  window.Forms = {

    init: function () {
      if($('.dreamform').length) {
        Forms.initForm();
        Forms.initProgressBar();
        if($('[data-search-ville]').length) Forms.initSearchMunicipality();
        if($('.week-selector').length) Forms.initCalendar();
      }
    },
    
    initForm: function () {
      const step        = $('.dreamform-step');
      let inputs_text   = $('[data-dreamform-text] input, [data-dreamform-text] textarea');
      let inputs_radio  = $('input[type="radio"]');

      step.fadeTo('slow', 1);

      inputs_text.on('input', function() {
        handlerInputsFilled(this);
      });

      inputs_text.each(function() {
        handlerInputsFilled(this);
      });

      function handlerInputsFilled(input) {
        if ($(input).val().trim() !== "") {
          $(input).addClass('field-filled');
        } else {
          $(input).removeClass('field-filled');
        }
      }
      
     /* inputs_radio.on('click', function() {
        if($(this).prop('checked')){
          $(this).removeAttr('checked');
        }
      });*/

      // Utiliser la fonction accordéon commune si disponible
      if (window.App && typeof App.initAccordion === 'function') {
        App.initAccordion();
      } else {
        // Fallback si App n'est pas disponible
        $('.accordion__button').on('click', function() {
          var $button = $(this);
          var containerId = $button.attr('aria-controls');
          var $container = $('#' + containerId);
          var isExpanded = $button.attr('aria-expanded') === 'true';
          var $contentHeight = $container.find('.accordion__content').outerHeight(true);
          
          $('.accordion__container').find('button, input, select, textarea, a, [tabindex]').attr('tabindex', '-1');
          
          $('.accordion__container').each(function() {
            $(this).removeClass('open').css('max-height', '0px');
          });
          
          $('.accordion__button').attr('aria-expanded', 'false');
          
          if (!isExpanded) {
            $container.find('button, input, select, textarea, a, [tabindex]').attr('tabindex', '0');
            $button.attr('aria-expanded', 'true');
            $container.addClass('open').css('max-height', $contentHeight + 'px');
          }
        });
      }

      if ($('[data-counter]').length) {
        $('[data-counter]').each((index, element) => {
          const els = $(element).find('[data-counter-el]');
          const counter = $(element).find('[data-counter-nb]');

          els.each((index, el) => {
            $( el ).on('change', () => {
              const checked = $(el).find('input[type="checkbox"]:checked');
              counter.text(checked.length);
            });
          });
        });
      }
    },
    
    initProgressBar: function () {
      const actualStep  = parseFloat(document.querySelector('[name="nav-idx"]').value) + 1;
      const progressBar = document.querySelector('.progress-bar');
      const nbSteps     = parseFloat(progressBar.getAttribute('aria-valuemax')) + 1;
      let progress = parseFloat(actualStep / nbSteps);
      
      progressBar.setAttribute('aria-valuenow', progress);
      progressBar.style.setProperty('--progress', progress);

      if(actualStep === nbSteps) {
        $('.dreamform__nav-wrapper-inner').css('display','none');
      }
    },

    initCalendar: function () {

      const calendar = $('#calendar-slots');
      const calendar_url = '/formulaire/scheduler';
      const selector_prev = $('.week-selector__prev');
      const selector_next = $('.week-selector__next');
      const selector_week = $('.selector-current-week');

      $('.js-week-selector').on('click touch', function (e) {
        e.preventDefault();
        let date_focus = $(this).data('date');
        loadCalendar(date_focus);
      });

      function loadCalendar(date_focus) {
        let url = date_focus ? calendar_url + '?date=' + date_focus : calendar_url;
        $.ajax({
          url: url,
          method: 'GET',
          dataType: 'json',
          cache: false,
          success: function(response) {
            selector_prev.data('date', response.content.prev);
            selector_next.data('date', response.content.next);
            selector_week.html(response.content.week);
            calendar.html(response.content.days);

            if(response.content.monday < response.content.date_left) 
              selector_prev.attr('disabled',1);
            else 
              selector_prev.removeAttr('disabled');

            if(response.content.next > response.content.date_right) 
              selector_next.attr('disabled',1);
            else 
              selector_next.removeAttr('disabled');
            
            $(".js-choose-call").click(function() {
              document.dispatchEvent(new CustomEvent("chooseCall"));
            });
          },
          error: function(error) {
            console.error(error); // Handle error response
          }
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          loadCalendar(selector_prev.data('date'));
        }
        else if (e.key === 'ArrowRight') {
          loadCalendar(selector_next.data('date'));
        }
      });

      loadCalendar();
    },
    
    initSearchMunicipality: function () {
      const resultsContainer = document.querySelector('[data-autocomplete-results]');
      if (!resultsContainer) return;
      
      const municipalityInput = document.querySelector('[data-search-ville]');
      if (!municipalityInput) return;

      const municipalityInputCode = document.querySelector('[data-search-code]');
      const municipalityInputCityCode = document.querySelector('[data-search-citycode]');
      
      const resultsList = resultsContainer.querySelector('ul');
      if (!resultsList) return;
      
      let searchTimeout;
      
      municipalityInput.addEventListener('input', function(e) {
        clearTimeout(searchTimeout);
        const query = e.target.value.trim();
       // console.log(query);
        
        if (query.length < 2) {
          resultsContainer.style.display = 'none';
          return;
        }
        
        searchTimeout = setTimeout(() => {
          fetch(`https://geo.api.gouv.fr/communes?nom=${query}&boost=population&limit=5`)
            .then(response => response.json())
            .then(data => {
              resultsList.innerHTML = '';
              
              if (data.length) {
               // console.log(data);
                resultsContainer.style.display = 'block';
                municipalityInput.setAttribute('aria-expanded', 'true');
                
                let selectedIndex = -1;
                
                function updateSelection(options) {
                  options.forEach((opt, i) => {
                    opt.setAttribute('aria-selected', i === selectedIndex);
                    if (i === selectedIndex) {
                      opt.focus();
                    }
                  });
                }
                
                function selectOption(commune, element) {
                  // console.log(commune);
                  municipalityInput.value = commune.nom;
                  municipalityInputCode.value = commune.codesPostaux[0];
                  municipalityInputCityCode.value = commune.code;
                  closeResults();
                }
                
                function closeResults() {
                  resultsContainer.style.display = 'none';
                  municipalityInput.setAttribute('aria-expanded', 'false');
                  selectedIndex = -1;
                }
                
                function handleKeyboardNavigation(e, options) {
                  switch(e.key) {
                    case 'ArrowDown':
                      if (selectedIndex === -1) {
                        selectedIndex = 0;
                      } else {
                        selectedIndex = (selectedIndex + 1) % options.length;
                      }
                      updateSelection(options);
                      options[selectedIndex].scrollIntoView({ block: 'nearest' });
                      break;
                    case 'ArrowUp': 
                      selectedIndex = Math.max(selectedIndex - 1, -1);
                      updateSelection(options);
                      break;
                    case 'Enter':
                      e.preventDefault();
                      if (selectedIndex >= 0) {
                        const selectedOption = options[selectedIndex];
                        const commune = data[selectedIndex];
                        selectOption(commune, selectedOption);
                      }
                      break;
                    case 'Escape':
                      closeResults();
                      break;
                  }
                }
                
                data.forEach((commune, index) => {
                  const li = document.createElement('li');
                  li.setAttribute('role', 'option');
                  li.setAttribute('id', `option-${commune.code}`);
                  li.textContent = `${commune.nom} (${commune.codeDepartement})`;
                  
                  li.addEventListener('click', () => selectOption(commune, li));
                  li.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      selectOption(commune, li);
                    }
                  });
                  
                  resultsList.appendChild(li);
                });
                
                municipalityInput.addEventListener('keydown', (e) => {
                  handleKeyboardNavigation(e, resultsList.querySelectorAll('li'));
                });
              } else {
                resultsContainer.style.display = 'none';
              }
            });
        }, 300);
      });

      // Close results if clicked outside
      document.addEventListener('click', (e) => {
        if (!resultsContainer.contains(e.target) && e.target !== municipalityInput) {
          resultsContainer.style.display = 'none';
        }
      });
    },
    
  };
  // ---------- APP END

  // Init app
  $(document).ready(Forms.init);
})(jQuery);


